"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
function endpointFactory(_a) {
    var baseUrl = _a.baseUrl, preview = _a.preview, environment = _a.environment;
    var result = baseUrl;
    if (environment) {
        result += "/environments/" + environment;
    }
    if (preview) {
        result += "/preview";
    }
    return result;
}
var Response500Error = /** @class */ (function (_super) {
    __extends(Response500Error, _super);
    function Response500Error(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, Response500Error.prototype);
        return _this;
    }
    return Response500Error;
}(Error));
var Response400Error = /** @class */ (function (_super) {
    __extends(Response400Error, _super);
    function Response400Error(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, Response400Error.prototype);
        return _this;
    }
    return Response400Error;
}(Error));
var InvalidResponseError = /** @class */ (function (_super) {
    __extends(InvalidResponseError, _super);
    function InvalidResponseError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, InvalidResponseError.prototype);
        return _this;
    }
    return InvalidResponseError;
}(Error));
function subscribeToQuery(options) {
    return __awaiter(this, void 0, void 0, function () {
        var query, token, variables, preview, environment, customFetcher, customEventSourceClass, onStatusChange, onUpdate, onChannelError, customReconnectionPeriod, customBaseUrl, fetcher, EventSourceClass, reconnectionPeriod, baseUrl, waitAndReconnect, channelUrl, req, registration, e_1;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    query = options.query, token = options.token, variables = options.variables, preview = options.preview, environment = options.environment, customFetcher = options.fetcher, customEventSourceClass = options.eventSourceClass, onStatusChange = options.onStatusChange, onUpdate = options.onUpdate, onChannelError = options.onChannelError, customReconnectionPeriod = options.reconnectionPeriod, customBaseUrl = options.baseUrl;
                    fetcher = customFetcher || window.fetch;
                    EventSourceClass = customEventSourceClass || window.EventSource;
                    reconnectionPeriod = customReconnectionPeriod || 1000;
                    baseUrl = customBaseUrl || "https://graphql-listen.datocms.com";
                    waitAndReconnect = function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, reconnectionPeriod); })];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/, subscribeToQuery(__assign(__assign({}, options), { reconnectionPeriod: (options.reconnectionPeriod || 1000) + reconnectionPeriod }))];
                            }
                        });
                    }); };
                    if (onStatusChange) {
                        onStatusChange("connecting");
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetcher(endpointFactory({ baseUrl: baseUrl, preview: preview, environment: environment }), {
                            headers: {
                                Authorization: "Bearer " + token,
                                Accept: "application/json"
                            },
                            method: "POST",
                            body: JSON.stringify({ query: query, variables: variables })
                        })];
                case 2:
                    req = _a.sent();
                    if (req.status >= 300 && req.status < 500) {
                        throw new Response400Error("Invalid status code: " + req.status + " " + req.statusText);
                    }
                    if (req.status >= 500) {
                        throw new Response500Error("Invalid status code: " + req.status + " " + req.statusText);
                    }
                    if (req.headers.get("Content-Type") !== "application/json") {
                        throw new InvalidResponseError("Invalid content type: " + req.headers.get("Content-Type"));
                    }
                    return [4 /*yield*/, req.json()];
                case 3:
                    registration = _a.sent();
                    channelUrl = registration.url;
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    if (e_1 instanceof Response400Error || e_1 instanceof InvalidResponseError) {
                        throw e_1;
                    }
                    if (e_1 instanceof Response500Error) {
                        // retry the connection
                        return [2 /*return*/, waitAndReconnect()];
                    }
                    if (e_1.message.includes("fetch")) {
                        // probably a CORS error due to network issues, retry the connection
                        return [2 /*return*/, waitAndReconnect()];
                    }
                    throw e_1;
                case 5: return [2 /*return*/, new Promise(function (resolve) {
                        var eventSource = new EventSourceClass(channelUrl);
                        var stopReconnecting = false;
                        var unsubscribe = function () {
                            if (eventSource.readyState !== 2) {
                                eventSource.close();
                            }
                        };
                        eventSource.addEventListener("open", function () {
                            if (onStatusChange) {
                                onStatusChange("connected");
                            }
                            resolve(unsubscribe);
                        });
                        eventSource.addEventListener("update", function (event) {
                            var updateData = JSON.parse(event.data);
                            onUpdate(updateData);
                        });
                        eventSource.addEventListener("channelError", function (event) {
                            var errorData = JSON.parse(event.data);
                            if (errorData.fatal) {
                                if (onStatusChange) {
                                    onStatusChange("closed");
                                }
                                stopReconnecting = true;
                                unsubscribe();
                            }
                            if (onChannelError) {
                                onChannelError(errorData);
                            }
                        });
                        eventSource.onerror = function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                eventSource.close();
                                if (!stopReconnecting) {
                                    waitAndReconnect();
                                }
                                return [2 /*return*/];
                            });
                        }); };
                    })];
            }
        });
    });
}
exports.subscribeToQuery = subscribeToQuery;
//# sourceMappingURL=index.js.map